import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { filterProps } from 'foundations-components/utils/filterProps';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
export const FullPriceContainerBlockLarge = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(Text, {
    typography: "heading-400",
    marginBlockEnd: "0",
    paddingInline: "0",
    display: "block",
    as: "div",
    children: /*#__PURE__*/_jsx("div", Object.assign({}, domProps, {
      children: children
    }))
  });
};
export const PriceContainer = styled.div.withConfig({
  displayName: "PriceStyledComponents__PriceContainer"
})(["line-height:initial;"]);
const ResponsiveSpan = styled.span.withConfig({
  displayName: "PriceStyledComponents__ResponsiveSpan"
})(() => {
  return {
    display: 'block',
    [trellisBreakpoint.tablet]: {
      display: 'inline'
    }
  };
});
export const MicroCopy = props => {
  return /*#__PURE__*/_jsx(ResponsiveSpan, {
    children: /*#__PURE__*/_jsx(Text, Object.assign({}, props, {
      as: "small",
      children: props.children
    }))
  });
};
export const StartsAtMicroCopy = /*#__PURE__*/_jsx(MicroCopy, {
  use: "help",
  "data-test-id": "starts-at",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "priceComponents.subtexts.startsAt"
  })
});